import React, { useCallback, useEffect } from 'react';
import { useRouteMatch } from 'react-router-dom';
// Types
import { UserProps } from 'types/user';
// Utils
import { validArray } from 'utils';
import { isActiveUser } from 'utils/user';
// Admin Context
import { useAdminState, useAdminDispatch } from 'context/AdminContext';
import { setAdminState, setUsers } from 'context/AdminContext/actions';
import { getUsers } from 'context/AdminContext/middleware';
// Assets
import Icon from 'assets/Icon';
// Elements
import Alert from 'elements/Alert';
import Button from 'elements/Button';
// Components
import PageHeader from 'components/PageHeader';
import UserCard from './components/UserCard';
import UserFilters from './components/UserFilters';
import styles from './style/userAdmin.module.css';

interface StateProps {
  filter: string,
  role: string,
  status: string,
  organisations: [],
}

function UserAdmin() {
  // Router
  const { path } = useRouteMatch();
  // Admin State
  const { adminState, users } = useAdminState();
  const adminDispatch = useAdminDispatch();

  const getData = useCallback(async () => {
    // await getOrganisations(adminDispatch);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [adminDispatch]);

  async function handleClear() {
    adminDispatch(setAdminState(''));
    adminDispatch(setUsers([]));
  }

  async function handleSubmit(state:StateProps) {
    const reqParams = {
      'limit': 100,
      'names[contains]': state.filter || undefined,
      role: state.role ? state.role.toUpperCase() : undefined,
      'orgRef[in]': validArray(state.organisations) ? state.organisations.join(',') : undefined,
      status: state.status || undefined,
    }
    await getUsers(adminDispatch, reqParams);
  }

  function renderUserCard(user:UserProps) {
    const { userId, organisations } = user;

    return (
      <UserCard
        defaultOrganisation={organisations}
        href={`${path}/amend-user/${userId}`}
        key={userId}
        status={isActiveUser(user)}
        user={user}
      />
    )
  }

  useEffect(() => {
    getData();
    return function cleanup() {
      adminDispatch(setUsers([]));
    };
  }, [adminDispatch, getData]);

  return (
    <>
      <PageHeader
        heading="Manage Users"
      />
      <UserFilters
        handleClear={() => handleClear()}
        handleSubmit={(state:StateProps) => handleSubmit(state)}
      />
      <div className="wrapper">
        <div className="wrapper__content">
          <Alert
            active={adminState === 'GET_USERS_SUCCESS' && !validArray(users)}
            label="No users found"
            type="info"
          />
          <Alert
            active={adminState === 'GET_USERS_ERROR'}
            label="No User found for given search condition"
            type="error"
          />
        </div>
        <div className={`wrapper__content wrapper__content_grid ${styles.userList}`}>
          {adminState === 'GET_USERS' ? (
            <>
              {[...Array(8)].map((e, i) => <UserCard key={i.toString()} loading />)}
            </>
          ) : (
            <>
              {validArray(users) && users.map(renderUserCard)}
            </>
          )}
        </div>
      </div>
      <div className="actionFloat">
        <Button
          btnStyle="primary"
          btnType="icon"
          elevation="32-8"
          href={`${path}/add-user`}
        >
          <Icon icon="Add" fill="white" size={32} />
        </Button>
      </div>
    </>
  );
}

export default UserAdmin;
